import axios from "axios";
import { API_BASE_URL, API_BASE_URL1, API_BASE_URL3 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
const getToken = () => {
    return localStorage.getItem("token");
  };

// export const ZoneWiseCollectionPointReportResult = async (requestData) => {
//     try {
//         const { Date, ShiftId } = requestData;
//         const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/ZoneWiseCollectionPointReport?Date=${Date}&ShiftId=${ShiftId}`, 
//         {
//             headers: {
//               Authorization: `Bearer ${getToken()}`
//             }
//           },
//         );
//         return response;
//     } catch (error) {
//         throw error
//     }
// };


export const ZoneWiseCollectionPointReportResult = async (requestData) => {
    try {
        const { Date, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `ZoneWiseCollectionPointClearedSummaryRport?Date=${Date}&ShiftId=${ShiftId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const ZoneWiseZoneCollectionPointReportResult = async (requestData) => {
    try {
        const { Date, ShiftId, zoneId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/ZoneWiseCollectionPointReport?Date=${Date}&ShiftId=${ShiftId}&zoneId=${zoneId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const ZoneWiseExistingGvp = async (requestData) => {
    try {
        const { ShiftId, zoneId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllGVPCollectionPoints?zoneId=${zoneId}&ShiftId=${ShiftId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};
export const TotalExistingGvp = async (requestData) => {
  try {
      const { ShiftId,} = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllGVPCollectionPoints?&ShiftId=${ShiftId}`, 
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const CircleWiseExistingGvp = async (requestData) => {
    try {
        const { ShiftId, circleId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllGVPCollectionPoints?ShiftId=${ShiftId}&circleId=${circleId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};
export const CircleWiseTotalExistingGvp = async (requestData) => {
  try {
      const { ShiftId} = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllGVPCollectionPoints?ShiftId=${ShiftId}`, 
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const CircleWiseCollectionPointReportResult = async (requestData) => {
    try {
        const { Date, ShiftId, zoneId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/CircleWiseCollectionPointReport?Date=${Date}&ShiftId=${ShiftId}&zoneId=${zoneId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};


export const CircleWiseCollectionPointReportResultNew = async (requestData) => {
    try {
        const { Date, ShiftId, zoneId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `CircleWiseCollectionPointClearedSummaryReport?Date=${Date}&ShiftId=${ShiftId}&zoneId=${zoneId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};



export const ZoneWiseGvpCleared = async (requestData) => {
    try {
        const { startDate, ZoneId, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetGVPTransactionsDetails?Date=${startDate}&ZoneId=${ZoneId}&ShiftId=${ShiftId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const ZoneWiseTotalGvpCleared = async (requestData) => {
  try {
      const { startDate, ShiftId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}`, 
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const ZoneWiseGvpClearedForReport = async (requestData) => {
    try {
        const { startDate, endDate, ZoneId, ShiftId, isHotspot } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetAllSecondaryCollectionTransaction?startDate=${startDate}&endDate=${endDate}&ZoneId=${ZoneId}&ShiftId=${ShiftId}&isHotspot=${isHotspot}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const CircleWiseGvpClearedForReport = async (requestData) => {
    try {
      const { startDate, circleId, ShiftId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetGVPTransactionsDetails?Date=${startDate}&CircleId=${circleId}&ShiftId=${ShiftId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const CircleWiseGvpClearedForTotalReport = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}`, 
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const CircleWiseGvpCleared = async (requestData) => {
    try {
        const { startDate, endDate, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetAllSecondaryCollectionTransaction?startDate=${startDate}&endDate=${endDate}&ShiftId=${ShiftId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const GetAllClearedCollectionTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}GetClearedCollectionPoints`, 
        {
            params: requestData ,
            headers: {
              Authorization: `Bearer ${getToken()}`,
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const GetAllClearedCollectionTransactionNewApi = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}GetClearedCollectionPoints`, 
        {
            params: requestData ,
            headers: {
              Authorization: `Bearer ${getToken()}`,
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };


    export const GetAllClearedNotInShift = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}GetClearedCollectionPoints_OtherThanShift`, 
        {
            params: requestData ,
            headers: {
              Authorization: `Bearer ${getToken()}`,
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };


  export const GetAllNotClearedCollectionTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetPendingCollectionPointsDetails`, 
        {
            params: requestData ,
            headers: {
              Authorization: `Bearer ${getToken()}`,
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };


  export const GetAllTotalClearedCollectionTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetAllClearedCollectionPointTransaction`, 
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`,
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  export const GetTotalAllClearedCollectionTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetAllClearedCollectionPointTransaction`, 
        {
            params: requestData ,
            headers: {
              Authorization: `Bearer ${getToken()}`,
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  export const GetAllClearedHotspotTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetAllClearedHotspotTransaction`,
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

    export const GetAllClearedHotspotTransactionNewApi = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}GetAllClearedHotspotTransaction`,
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };


  
    export const GetAllTotalClearedNewApi = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}GetClearedCollectionPointsUnified`,
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };



  export const GetAllClearedHotspotTransactionTotal = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetAllClearedHotspotTransaction`,
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const GetAllTotalClearedHotspotTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetAllClearedHotspotTransaction`,
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const GetTotalAllClearedHotspotTransaction = async (requestData) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}TransactionReport/GetAllClearedHotspotTransaction`,
        {
            params: requestData,
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
export const CircleWiseTotalGvpCleared = async (requestData) => {
    try {
        const { startDate, endDate, ShiftId, circleId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `TransactionReport/GetAllSecondaryCollectionTransaction?startDate=${startDate}&endDate=${endDate}&ShiftId=${ShiftId}&circleId=${circleId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const ZoneWiseCollectionPointReportResultOld = async (requestData) => {
    try {
        const { Date, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/OldZoneWiseCollectionPointClearanceReport?Date=${Date}&ShiftId=${ShiftId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const CircleWiseCollectionPointReportResultOld = async (requestData) => {
    try {
        const { Date, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/OldCircleWiseCollectionPointClearanceReport?Date=${Date}&ShiftId=${ShiftId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const DateWiseCollectionPointReportResult = async (requestData) => {
    try {
        const { StartDate, EndDate } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/DateWiseCollectionPointReport?StartDate=${StartDate}&EndDate=${EndDate}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleClearanceReportZoneWiseReportResult = async (requestData) => {
    try {
        const { Date, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `MulipleClearanceReportZoneWiseReport?Date=${Date}&ShiftId=${ShiftId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleClearanceReportCircleWiseReportResult = async (requestData) => {
    try {
        const { Date, ShiftId, zoneId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `MulipleClearanceReportCircleWiseReport?Date=${Date}&ShiftId=${ShiftId}&zoneId=${zoneId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};


export const MulipleClearanceZoneExistingGVPReportResult = async (requestData) => {
    try {
        const { ShiftId, zoneId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL3 + `Routes/GetAllCollectionPoints?zoneId=${zoneId}&ShiftId=${ShiftId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const TotalMulipleClearanceZoneExistingGVPReportResult = async (requestData) => {
  try {
      const { ShiftId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL3 + `Routes/GetAllCollectionPoints?&ShiftId=${ShiftId}`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const MulipleClearanceCircleExistingGVPReportResult = async (requestData) => {
    try {
        const { ShiftId, circleId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL3 + `Routes/GetAllCollectionPoints?ShiftId=${ShiftId}&circleId=${circleId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleClearanceCircleExistingGVPReportTotalResult = async (requestData) => {
  try {
      const { ShiftId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL3 + `Routes/GetAllCollectionPoints?ShiftId=${ShiftId}`, 
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const MulipleOneTimeReportZoneWiseReportResult = async (requestData) => {
    try {
        const { startDate, ShiftId, zoneId, circleId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?date=${startDate}&shiftId=${ShiftId}&ZoneId=${zoneId}&CircleId=${circleId}&TripTypeId=1`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleOneTimeReportReportTotalResult = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=1`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const MulipleOneTimeReportZoneWiseReportTotalResult = async (requestData) => {
  try {
      const { startDate, ShiftId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=1`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};
export const MulipleMultipleTimeReportCircleWiseReportResult = async (requestData) => {
    try {
      const { startDate, ShiftId, circleId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&CircleId=${circleId}&TripTypeId=4`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};
export const MulipleMultipleTimeReportTotalReportResult = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=4`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const MulipleOneTimeReportCircleWiseReportResult = async (requestData) => {
    try {
        const { startDate, endDate, ShiftId, circleId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `TransactionReport/GetAllSecondaryCollectionOneTimeTransaction?startDate=${startDate}&endDate=${endDate}&ShiftId=${ShiftId}&circleId=${circleId}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleTwoTimeReportZoneWiseReportResult = async (requestData) => {
    try {
        const { startDate, ShiftId, zoneId, circleId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&ZoneId=${zoneId}&CircleId=${circleId}&TripTypeId=2`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleTwoTimeReportZoneWiseTotalReportResult = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=2`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const MulipleTwoTimeReportZoneWiseReportTotalResult = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=2`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};
export const MulipleThreeTimeReportZoneWiseReportResult = async (requestData) => {
    try {
      const { startDate, ShiftId, zoneId, circleId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&ZoneId=${zoneId}&CircleId=${circleId}&TripTypeId=3`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleThreeTimeReportZoneWiseReportTotalResult = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=3`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};

export const MulipleMoreThanThreeTimeReportZoneWiseReportResult = async (requestData) => {
    try {
      const { startDate, ShiftId, zoneId } = requestData;
      const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&ZoneId=${zoneId}&TripTypeId=4`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MulipleMoreThanThreeTimeReportZoneWiseReportTotalResult = async (requestData) => {
  try {
    const { startDate, ShiftId } = requestData;
    const response = await axiosInstance.get(API_BASE_URL + `GetGVPTransactionsDetails?Date=${startDate}&ShiftId=${ShiftId}&TripTypeId=4`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response;
  } catch (error) {
      throw error
  }
};



export const CollectionPointDayClearanceZoneWiseReportResult = async (requestData) => {
    try {
        const { Date } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/CollectionPointDayClearanceZoneWiseReport?Date=${Date}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const CollectionPointDayClearanceCircleWiseReportResult = async (requestData) => {
    try {
        const { Date } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/CollectionPointDayClearanceCircleWiseReport?Date=${Date}`, 
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response;
    } catch (error) {
        throw error
    }
};

export const MasterCollectionPointReportResult = async (requestData) => {
    try {
        const { ZoneId, CircleId, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/CollectionPointMasterReport?ZoneId=${ZoneId}&CircleId=${CircleId}&ShiftId=${ShiftId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response.data;
    } catch (error) {
        throw error
    }
};

export const ClearnaceCollectionPointReportResult = async (requestData) => {
    try {
        const { StartDate, EndDate, ZoneId, CircleId, ShiftId, WardId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/CollectionPointClearanceReport?StartDateTime=${StartDate}&EndDateTime=${EndDate}&ZoneId=${ZoneId}&CircleId=${CircleId}&WardId=${WardId}&ShiftId=${ShiftId}`,
        {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
        );
        return response.data;
    } catch (error) {
        throw error
    }
};

export const GVPClearanceDateReports = async (StartDate, EndDate,vehicleType) => {
  try {
      // const { StartDate, EndDate,} = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/DateWiseCollectionPointReport?StartDate=${StartDate}&EndDate=${EndDate}&VehicleTypeId=${vehicleType}`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response.data;
  } catch (error) {
      throw error
  }
};
 
export const GVPClearanceInnerDownload = async (FromDate, ToDate, VehicleTypeId) => {
  try {
      // const { StartDate, EndDate,} = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/GetGVPClearanceReportByDate?FromDate=${FromDate}&ToDate=${ToDate}&VehicleTypeId=${VehicleTypeId}`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response.data;
  } catch (error) {
      throw error
  }
};

export const HotspotClearanceInnerDownload = async (FromDate, ToDate, VehicleTypeId) => {
  try {
      // const { StartDate, EndDate,} = requestData;
      const response = await axiosInstance.get(API_BASE_URL1 + `CollectionPointReport/GetHotspotClearanceReportByDate?FromDate=${FromDate}&ToDate=${ToDate}&VehicleTypeId=${VehicleTypeId}`,
      {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
      );
      return response.data;
  } catch (error) {
      throw error
  }
};
 
export const DeleteGVPClearedRecord = async (secondaryCollectionId) => {
  try {
    const response = await axiosInstance.delete(
      `${API_BASE_URL1}SecondaryCollection/DeleteSecondaryCollectionImages?secondaryCollectionId=${secondaryCollectionId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        }
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};